import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./help-modal.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./help-modal.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
export let HelpModalComponent = class HelpModalComponent {
    activeModal;
    dialogTitle;
    helpMessage;
    closeBtnPlaceholder = "Close";
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    ngOnInit() {
    }
    onCloseBtnClicked() {
        this.activeModal.close();
    }
    static ctorParameters = () => [
        { type: NgbActiveModal }
    ];
    static propDecorators = {
        dialogTitle: [{ type: Input }],
        helpMessage: [{ type: Input }]
    };
};
HelpModalComponent = __decorate([
    Component({
        selector: "app-help-modal", template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], HelpModalComponent);
